<template>
    <!-- 下载 -->
    <div class="version-chain">
      <v-dialog
      name="basic-t"
      v-model="isShow"
      :title="dialogTitle"
      :close-on-click-modal="closeOnClickModal1"
      :modal="true"
      :width="668"
      @open="open"
      @confirm="handleConfirm"
      @after-close="handleAfterClose"
      v-bind:confirmButtonText= "suredown"
      append-to-body
    >
              <div class="main-box">
                  <div class="horizontal-array" v-for="(item,index) in forData" v-bind:key="index">

                    <div class="inner-array" :class="[ itemdata.software_version == chainSoftware_version ? 'yes-check':'not-check']" v-for="(itemdata,i) in item" v-bind:key="i" >
                      <v-popover
                        class="popover-demo"
                        width="auto"
                        trigger="hover"
                        position="right-top"
                      >
                        <div>版本ID：<span class="boodBlack">{{itemdata.id}}</span></div>
                        <div>产品：<span class="boodBlack">{{itemdata.productName}}</span></div>
                        <div>软件版本：<span class="boodBlack">{{itemdata.software_version}}</span></div>
                        <div>版本类型：<span class="boodBlack">{{itemdata.version_type}}</span></div>
                        <div>支持语言：<span class="boodBlack">{{itemdata.language}}</span></div>

                        <span slot="reference" class="inlinebliok">{{ itemdata.productName }}</span>
                        <span slot="reference" class="inlinebliok">{{ itemdata.software_version }}</span>
                      </v-popover>
                      <span class="right-line overstep" v-if="i===0 && forData.length !==(index+1)"></span>
                      <span class="left-line overstep" v-if="i!==0 && forData.length !==(index+1)"></span>
                    </div>
                  </div>
              </div>
            </v-dialog>
      </div>
</template>

  <script>

  export default {
    components: {},
    props:{
        showAddDialog:{
        type:Boolean,
        default: false
      },
      chainId:{
      },
      chainSoftware_version:{
        type:String,
        default:'',
      }
    },
    data() {
      return {
        dialogTitle: "软件版本链",
        closeOnClickModal1: true, //点击周围关闭弹窗
        suredown:"确定",
        isShow:false,
        forData:[],
        productKeyOptins:[]
        // currentModel:''
      };
    },
    created() {
    },
    watch:{
      showAddDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){
        this.getProductList()
        this.getData()
      },
      async getData(){
      const res = await this.$getData(
        `/td/td-iot-api/iot/firmware/chain/v1/${this.chainId}`,
      );
      this.forData = res.data.list
      this.forData.forEach((item)=>{
        this.productKeyOptins.map((i)=>{
            if(item[0].product_key == i.value){
              item[0].productName = i.label
            }
          })
      })
    },
    getProductList(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.productKeyOptins = res.data.map((item) =>{
              return {
                label: item.product_name,
                value: item.product_key
              }
            })
          }else {
            this.$message.error(res.msg);
          }
        });
      },
      handleConfirm() {
        this.$emit('update:showAddDialog',false)

        this.forData = []
      },
        handleAfterClose() {
          this.$emit('update:showAddDialog',false)

        this.forData = []
        },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  .main-box{
   margin-left: 180px;
   width: 1200px;
  }
    .horizontal-array{
      height: 100px;
      margin-top: 20px;
      padding: 20px;
    }
    .inner-array{
      float: left;
      height: 50px;
      width: 225px;
      margin-right: 17px;
      margin-top: 2px;
      padding: 6px;
      text-align: center;
      background-color:  #FFFFFF;
      position: relative;
      border-radius: 3px;
      border: 0.5px solid #D8D8D8;
    }
    .left-line{
      position: absolute;
      display: inline-block;
      width: 116px;
      height: 36px;
      top: 50px;
      right: 50px;
      border-right: 1px dashed rgb(89,89,89);
      border-bottom: 1px dashed rgb(89,89,89);
    }
    .right-line{
      position: absolute;
      display: inline-block;
      width: 2px;
      height: 70px;
      top: 50px;
      right: 109px;
      border-right: 1px dashed rgb(89,89,89);
    }
    .inlinebliok{
      height: 20px;
      display: block;
      margin-top: -1px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 200px;
    }
    .boodBlack{
      font-weight: 600;
      color: #595959;
    }

  </style>
